import api from './index'
import { axios } from '@/utils/request'
import { BaseURL } from "@/utils/config"

export function getListTeacher(parameter) {
    return axios({
        url: BaseURL + api.Teacher + 'list',
        method: 'GET',
        params: parameter
    })
}
export function createTeacher(parameter) {
    return axios({
        url: BaseURL + api.Teacher + 'create',
        method: 'POST',
        data: parameter
    })
}
export function search(parameter) {
    return axios({
        url: BaseURL + api.Teacher + "search",
        method: "GET",
        params: parameter,
    });
}
export function getProfileTeacher(parameter) {
    return axios({
        url: BaseURL + api.Teacher + 'get_profile_teacher',
        method: 'GET',
        params: parameter
    })
}

export function updateTeacher(parameter) {
    return axios({
        url: BaseURL + api.Teacher + 'update',
        method: 'POST',
        data: parameter
    })
}
export function banTeacher(parameter) {
    return axios({
        url: BaseURL + api.Teacher + 'ban',
        method: 'POST',
        data: parameter
    })
}

export function approveTeacher(parameter){
    return axios({
        url: BaseURL + api.Teacher + 'approve',
        method: 'POST',
        data: parameter
    })
}

export function rejectTeacher(parameter){
    return axios({
        url: BaseURL + api.Teacher + 'reject',
        method: 'POST',
        data: parameter
    })
}